import * as React from 'react'
import styled from 'styled-components'
import Button from '@doordash/component-button'
import {
  Colors,
  Stack,
  BorderRadius,
  StackChildren,
} from '@doordash/design-language'
import { ErrorMessage } from '@doordash/component-fields'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const SignaturePad = require('signature_pad')

const CanvasWrapper = styled(Stack)`
  canvas {
    border: ${(props: { hasError: boolean }) =>
      props.hasError
        ? `1px solid ${Colors.FieldsBorderError}`
        : `1px solid ${Colors.BorderPrimary}`};
    border-radius: ${BorderRadius.Medium}px;
    background-color: ${(props: { hasError: boolean }) =>
      props.hasError ? `${Colors.SystemRed5}` : `transparent`};
  }
`

type SignatureCanvasProps = {
  onChange: (dataUrl: string) => void
  error: string
}

const SignatureCanvas = ({ onChange, error }: SignatureCanvasProps) => {
  const canvasRef = React.useRef<HTMLCanvasElement>(null)
  const [signaturePad, setSignaturePad] = React.useState(null)

  React.useEffect(() => {
    if (!canvasRef.current) {
      return
    }
    setSignaturePad(new SignaturePad(canvasRef.current))
  }, [canvasRef])

  React.useEffect(() => {
    if (signaturePad) {
      signaturePad.onEnd = () =>
        onChange(formatDataURL(canvasRef.current.toDataURL()))
    }
  }, [onChange, signaturePad])

  const formatDataURL = (url: string) => {
    return url.replace(/^data:image\/(png|jpg);base64,/, '')
  }

  return (
    <>
      <CanvasWrapper hasError={!!error} size={StackChildren.Sizes.XxSmall}>
        <canvas ref={canvasRef} />
      </CanvasWrapper>
      <StackChildren size={StackChildren.Sizes.XSmall}>
        {error && <ErrorMessage error={error} />}
        <Button
          type={Button.Types.Tertiary}
          size={Button.Sizes.Small}
          onClick={() => {
            onChange('')
            signaturePad.clear()
          }}
          isInline
        >
          Clear Signature
        </Button>
      </StackChildren>
    </>
  )
}

export default SignatureCanvas
